import { Swiper, SwiperSlide } from 'swiper/react'; // eslint-disable-line
import { Pagination, Autoplay } from 'swiper';

const FeesProcess = ({ data }) => {
  return (
    <div className="section__fees-process">
      <h2>{data?.title}</h2>
      <p className="subtitle_1">{data?.description}</p>
      <div className="section__fees-process__cards">
        {data.feesCard &&
          data.feesCard.map(({ image, heading, description }) => (
            <div className="section__fees-process__card">
              <div className="section__fees-process__card__image" data-bg={image.sourceUrl ? image.sourceUrl : ''} />
              <h5>{heading}</h5>
              <p>{description}</p>
            </div>
          ))}
      </div>
      <div className="section__fees-process__slider">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination
          slidesPerView={1}
          autoplay={{
            delay: 4000,
          }}
        >
          {data.feesCard &&
            data.feesCard.map(({ mobileImage, heading, description }) => (
              <SwiperSlide>
                <div className="section__fees-process__slider__card">
                  <div
                    className="section__fees-process__slider__card__image"
                    data-bg={mobileImage?.sourceUrl ? mobileImage.sourceUrl : ''}
                  />
                  <h3>{heading}</h3>
                  <p>{description}</p>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
      <p>{data?.bottomText}</p>
    </div>
  );
};

export default FeesProcess;
